/****   httpYzb.js - 药尊宝第三方API请求配置   ****/
// 导入axios
import axios from "axios";
import CryptoJS from 'crypto-js';

// 药尊宝API配置常量
const YZB_CONFIG = {
  SUPPLIER_ID: '10000002',  // 供应商ID
  SECRET_KEY: 'ADE12424-62BB-11F0-AA68-FA163E3DABEC'  // 华丰密钥
};

// 生成签名的函数
const generateSignature = (timestamp, jsonBody, secretKey, supplierId) => {
  // 计算方法：签名字符串=HEX(SHA1(JSON取文字符串+时间戳+密钥))，注：计算出来的40位符号名转为大写。
  const signString = jsonBody + timestamp + secretKey;
  const sha1Hash = CryptoJS.SHA1(signString).toString(CryptoJS.enc.Hex);
  return sha1Hash.toUpperCase();
};

//1. 创建专门用于药尊宝API的axios实例
const yzbService = axios.create({
  // 药尊宝API生产环境地址
  baseURL: "https://api.yzunbao.com",
  // 超时时间 单位是ms，设置为30秒
  timeout: 30 * 1000
});

// 2.请求拦截器
yzbService.interceptors.request.use(
  config => {
    // 生成10位UTC时间戳
    const timestamp = Math.floor(Date.now() / 1000);
    
    // 确保有请求体数据
    if (!config.data) {
      config.data = {};
    }
    
    // 将请求体转换为JSON字符串
    const jsonBody = JSON.stringify(config.data);
    
    // 生成签名
    const signature = generateSignature(timestamp, jsonBody, YZB_CONFIG.SECRET_KEY, YZB_CONFIG.SUPPLIER_ID);
    
    // 设置请求头
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      "systemtimestamp": timestamp,  // 时间戳
      "systemsignature": signature,   // 签名字符串
      "supplier": YZB_CONFIG.SUPPLIER_ID  // 供应商ID
    };
    
    // 确保请求体是JSON格式
    config.data = jsonBody;
    
    console.log('=== 药尊宝API请求详情 ===');
    console.log('请求URL:', config.baseURL + config.url);
    console.log('时间戳:', timestamp);
    console.log('请求体:', jsonBody);
    console.log('签名:', signature);
    console.log('供应商ID:', YZB_CONFIG.SUPPLIER_ID);
    console.log('请求头:', config.headers);
    
    return config;
  },
  err => {
    console.error('药尊宝API请求错误:', err);
    return Promise.reject(err);
  }
);

// 3.响应拦截器
yzbService.interceptors.response.use(
  response => {
    console.log('药尊宝API响应:', response);
    return response;
  },
  error => {
    console.error('药尊宝API响应错误:', error);
    // 处理跨域和网络错误
    if (error.code === 'ERR_NETWORK' || error.message.includes('CORS')) {
      console.error('药尊宝API跨域或网络错误:', error.message);
    }
    return Promise.reject(error);
  }
);

// 4. 导出药尊宝专用的HTTP方法
const yzbHttps = {
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url, params) {
        const config = {
            method: 'get',
            url: url
        }
        if (params) config.params = params
        return yzbService(config)
    },
    post(url, params) {
        const config = {
            method: 'post',
            url: url
        }
        if (params) config.data = params
        return yzbService(config)
    },
    put(url, params) {
        const config = {
            method: 'put',
            url: url
        }
        if (params) config.params = params
        return yzbService(config)
    },
    delete(url, params) {
        const config = {
            method: 'delete',
            url: url
        }
        if (params) config.params = params
        return yzbService(config)
    }
}

// 导出
export default yzbHttps



// WEBPACK FOOTER //
// ./src/utils/httpYzb.js